export default {
    pleaseCompleteSecurityVerification: "Por favor, complete a verificação de segurança",
    slideToTheRightToValidation: "Deslize para a direita para concluir a validação",
    verificationSuccessful: "Verificação bem-sucedida",
    verificationFailed: "Falha na validação"
}